import React from "react";
import { Link } from "gatsby";
import { useSiteMetadata } from "../../../hooks/defaults/Use-SiteMetadata";
var slugify = require("slugify");

const Header = ({ related_service, area }) => {
	const { title } = useSiteMetadata();
	return (
		<>
			<div className="hidden sm:block">
				<div className="max-w-screen-xl md:flex mx-auto px-4 sm:px-6 lg:px-8 mt-6  text-gray-600">
					<Link to="/">
						<p id="breadcrumbs" className=" pr-2 hover:underline">
							{`${title}`}
						</p>
					</Link>
					<div>/</div>
					<Link to={`/${slugify(related_service, { lower: true })}`}>
						<p id="breadcrumbs" className=" px-2 hover:underline">
							{`${related_service}`}
						</p>
					</Link>
					<div>/</div>

					<p id="breadcrumbs" className=" px-2">
						{`${area}`}
					</p>
				</div>
			</div>
		</>
	);
};

export default Header;
